import { render, staticRenderFns } from "./BannerCenteredSimple.vue?vue&type=template&id=99f59b10&"
import script from "./BannerCenteredSimple.vue?vue&type=script&lang=js&"
export * from "./BannerCenteredSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports